var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-matching')
}
var staticRenderFns = []

export { render, staticRenderFns }